import React, { Component, Fragment } from "react";
import GoogleAd from "./GoogleAd";

const ELLIPSES = "…";
const SHOW_LESS_TEXT = "- Less";
const SHOW_MORE_TEXT = "+ More";

export default class ReadMore extends Component {
  static defaultProps = {
    characterLimit: 200,
    showLessButton: true,
  };

  state = {
    showingAll: false,
  };

  toggleReadMore = () => {
    this.setState({
      showingAll: !this.state.showingAll,
    });
  };

  getReadMoreParts = ({ text, characterLimit, ad }) => {
    let teaserText;
    let teaserText0;
    let remainingText;
    const remainingWordsArray = [];

    if (text) {
      let updatedText = text;
      if (ad) {
        const adWordsArray = text.split("<hr>");
        if (adWordsArray.length > 1) {
          teaserText0 = adWordsArray.shift();
          updatedText = `<hr>${adWordsArray.join("<hr>")}`;
        }
        if (!teaserText0) {
          const adWordsArray = text.split("<h2>");
          if (adWordsArray.length > 1) {
            teaserText0 = adWordsArray.shift();
            updatedText = `<h2>${adWordsArray.join("<h2>")}`;
          }
        }
      }

      const teaserWordsArray = updatedText.split(" ");

      while (teaserWordsArray.join(" ").length > characterLimit) {
        remainingWordsArray.unshift(teaserWordsArray.pop());
      }

      teaserText = teaserWordsArray.join(" ");

      if (remainingWordsArray.length > 0) {
        remainingText = remainingWordsArray.join(" ");
      }
    }

    return {
      teaserText0,
      teaserText,
      remainingText,
    };
  };

  insertAds = (text, ad = "leaderboard_lazy") => {
    const texts = text.split("<ad>");

    return texts.map((txt, idx) => (
      <Fragment key={idx}>
        <div dangerouslySetInnerHTML={{ __html: `${txt.replace(/\s*$/, "")}` }} />
        {idx < texts.length - 1 && <GoogleAd section={ad} />}
      </Fragment>
    ));
  };

  getAdsParts = ({ text, ad }) => {
    let mainText = text;
    let mainText0;

    if (text && ad) {
      const adWordsArray = text.split("<hr>");
      if (adWordsArray.length > 1) {
        mainText0 = adWordsArray.shift();
        mainText = `<hr>${adWordsArray.join("<hr>")}`;
      }
      if (!mainText0) {
        const adWordsArray = text.split("<h2>");
        if (adWordsArray.length > 1) {
          mainText0 = adWordsArray.shift();
          mainText = `<h2>${adWordsArray.join("<h2>")}`;
        }
      }
    }

    return {
      mainText0,
      mainText,
    };
  };

  getText = ({ showingAll, text, characterLimit, ad }) => {
    const { teaserText, teaserText0 } = this.getReadMoreParts({ text, characterLimit, ad });
    const { mainText, mainText0 } = this.getAdsParts({ text, ad });

    if (!showingAll && text.length > characterLimit) {
      return (
        <>
          {ad && teaserText0 && (
            <>
              {this.insertAds(teaserText0)}
              <GoogleAd section={ad} />
            </>
          )}
          {this.insertAds(teaserText)}
        </>
      );
    }

    return (
      <>
        {ad && mainText0 && (
          <>
            {this.insertAds(mainText0)}
            <GoogleAd section={ad} />
          </>
        )}
        {this.insertAds(mainText)}
      </>
    );
  };

  getActionButton = ({ showingAll, showLessButton, text, characterLimit }) => {
    if (showingAll && !showLessButton) {
      return;
    }

    const { remainingText } = this.getReadMoreParts({ text, characterLimit });
    const buttonText = showingAll ? SHOW_LESS_TEXT : SHOW_MORE_TEXT;

    if (remainingText && remainingText.length > 0) {
      return (
        <div className="more-link">
          <button onClick={this.toggleReadMore}>{buttonText}</button>
        </div>
      );
    } else {
      return;
    }
  };

  render() {
    const { text, characterLimit, showLessButton, ad } = this.props;

    const { showingAll } = this.state;
    const textToDisplay = this.getText({ showingAll, text, characterLimit, ad });
    const actionButton = this.getActionButton({ showingAll, showLessButton, text, characterLimit });

    return (
      <>
        <style jsx global>{`
          .read-more {
            line-height: 1.4;
          }
          .more-link {
            text-align: center;
            margin-top: 0.75rem;
          }
          .read-more .more-link button {
            border: none;
            background: transparent;
            font-size: 1rem;
            color: inherit;
            cursor: pointer;
          }
          .read-more .more-link button:hover,
          .read-more .more-link button:focus,
          .read-more .more-link button:active {
            opacity: 0.8;
          }
        `}</style>
        <div className="read-more">
          <div>{textToDisplay}</div> {actionButton}
        </div>
      </>
    );
  }
}
